<template lang="pug">
  div
    header.app-header
      .app-header__callback.mr-1(v-if="isVisibleButton")
        v-btn(
          icon
          @click="goToBack")
          v-icon(
            font-size="1.1"
            icon="chevron-left")
      .app-header__menu(
        v-if="!isDesktop && $route.params.farm_id !== undefined")
        v-dropdown(width-auto)
          v-btn.mr-1(icon)
            v-icon(icon="bars")
          template(slot="content")
            farm-sidebar

      .app-header__logo(@click="goBack")
        i.i-header-logo(
          v-if="!isMobile")
        .app-header__logo-title PROFEED
      header-breadcrumb(
        v-if="isDesktop"
        @toggle-menu="toggleMenu")
      .app-header__settings
        .app-header__lang
          onboarding-button
          lang-switcher-dropdown(v-if="!isMobile")
        app-settings(v-if="isMobile")
        user-profile(v-else)

    header-menu(
      :show-menu="showMenu"
      @close="showMenu = false")
</template>

<script>
import HeaderBreadcrumb from './HeaderBreadcrumb.vue'
import HeaderMenu from './HeaderMenu.vue'
import UserProfile from './user-profile/UserProfile.vue'
import AppSettings from './app-settings/AppSettings'

import FarmSidebar from '@/components/layouts/farm-sidebar/FarmSidebar'

import adaptationMixin from '@/mixins/adaptation.mixin.js'
import LangSwitcherDropdown from '@/components/layouts/app-header/LangSwitcherDropdown.vue'
import OnboardingButton from '@/components/layouts/app-header/OnboardingButton.vue'

export default {
  name: 'AppHeader',

  mixins: [
    adaptationMixin
  ],

  components: {
    LangSwitcherDropdown,
    OnboardingButton,
    HeaderBreadcrumb,
    HeaderMenu,
    UserProfile,
    AppSettings,
    FarmSidebar
  },

  data: () => ({
    showMenu: false
  }),

  computed: {
    lang () {
      const language = this.$store.getters['account/lang']
      return language === 'us' ? 'en' : language
    },
    farmsPath () {
      return this.$route.path.includes('farms')
    },

    isVisibleButton () {
      return this.isMobile &&
        this.isAdmin &&
        this.farmsPath
    }
  },

  methods: {
    toggleMenu () {
      this.showMenu = !this.showMenu
    },
    goToBack () {
      this.$router.go(-1)
    },

    goBack () {
      if (this.isAdmin || this.isStaff) {
        this.$router.push('/app/activities')
      } else if (this.isConsultant) {
        this.$router.push('/app/clients')
      } else {
        this.$router.push('/app/companies')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/abstracts/_variables.scss';

.app-header {
  position: fixed;
  z-index: 100;
  width: 100%;
  height: 7rem;
  padding: 0 1.5rem 0 2rem;
  display: flex;
  align-items: center;
  background-color: $color-white;
  box-shadow: 0 1px 6px 0 rgba(131, 94, 94, 0.2);

  &__logo {
    cursor: pointer;
    display: flex;
    align-items: center;

    i {
      margin-right: 2rem;
    }

    &-title {
      font-size: 30px;
      font-weight: bold;
      font-family: 'RoadRadio', sans-serif;
    }
  }

  &__settings {
    margin-left: auto;
  }

  &__lang{
    position: absolute;
    right: 295px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    gap: 30px;
    @media screen and (max-width: 800px) {
      right: 60px;
    }
  }
}
</style>
